import UAParser from "ua-parser-js";
let deviceInfo = {};
const getDeviceInfo = () => {
  var _a, _b, _c, _d;
  if (Object.keys(deviceInfo).length) {
    return deviceInfo;
  }
  const parser = new UAParser();
  const res = parser.getResult();
  const { browser, os } = res;
  deviceInfo = {
    platform: "Web",
    browser: (_a = browser == null ? void 0 : browser.name) != null ? _a : "",
    browser_version: (_b = browser == null ? void 0 : browser.version) != null ? _b : "",
    os: (_c = os == null ? void 0 : os.name) != null ? _c : "",
    os_version: (_d = os == null ? void 0 : os.version) != null ? _d : ""
  };
  return deviceInfo;
};
export {
  getDeviceInfo
};
